import { format } from 'date-fns';
import { TZDate, tzName } from '@date-fns/tz';
const getTimezoneDate = (date, timezone) => {
    if (!timezone) {
        return date;
    }
    return new TZDate(new Date(date), timezone);
};
const getTimezoneName = (timezone, date) => {
    return tzName(timezone, new Date(date), 'short');
};
export const formatTermDate = (date) => {
    return format(date, 'MMM d, yyyy');
};
export const formatMeetingDate = (date, options = {}) => {
    const formatted = format(getTimezoneDate(date, options.timezone), options.format || 'EEEE, MMMM d, yyyy');
    if (!options.appendTimezone || !options.timezone) {
        return formatted;
    }
    return `${formatted} ${getTimezoneName(options.timezone, date)}`;
};
export const formatMeetingDateTime = (date, timezone) => {
    const formatted = format(getTimezoneDate(date, timezone), "EEEE, MMMM d, yyyy 'at' h:mm a");
    return `${formatted} ${getTimezoneName(timezone, date)}`;
};
export const formatDateTime = (date, options = {}) => {
    const formatted = format(getTimezoneDate(date, options.timezone), options.format || 'M/d/yy h:mm a');
    if (!options.appendTimezone || !options.timezone) {
        return formatted;
    }
    return `${formatted} ${getTimezoneName(options.timezone, date)}`;
};
export const formatTime = (date, options = {}) => {
    const formatted = format(getTimezoneDate(date, options.timezone), 'h:mm a');
    if (!options.appendTimezone || !options.timezone) {
        return formatted;
    }
    return `${formatted} ${getTimezoneName(options.timezone, date)}`;
};
/**
 * Formats a term length in months to a human-readable duration string.
 * @param termLength - Term length in months, or -1 for unlimited duration
 * @returns A formatted duration string (e.g., "2 years, 3 months" or "No term duration")
 */
export const formatTermDuration = (termLength) => {
    if (termLength === -1) {
        return 'No term duration';
    }
    const years = Math.floor(termLength / 12);
    const months = termLength % 12;
    if (years > 0 && months > 0) {
        return `${years} year${years > 1 ? 's' : ''}, ${months} month${months > 1 ? 's' : ''}`;
    }
    else if (years > 0) {
        return `${years} year${years > 1 ? 's' : ''}`;
    }
    else {
        return `${months} month${months > 1 ? 's' : ''}`;
    }
};
/**
 * Formats a duration in seconds as a compact, human-readable string: `1h 23m`, `12m 5s`, or `45s`.
 * Seconds are truncated to whole numbers; non-positive input returns `0s`.
 *
 * @param totalSeconds - Duration in seconds.
 * @returns A compact duration string.
 */
export const formatDurationShort = (totalSeconds) => {
    const seconds = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }
    if (minutes > 0) {
        return `${minutes}m ${remainingSeconds}s`;
    }
    return `${remainingSeconds}s`;
};
export const formatSeatApplicationSubmissionDeadline = (date, timezone) => {
    const formattedForTimezone = format(getTimezoneDate(date, timezone), 'MMM d, yyyy h:mm a');
    return `${formattedForTimezone} ${getTimezoneName(timezone, date)}`;
};
